export default __webpack_public_path__ + "static/media/arrow.16b72606.svg";